<template>
  <div class="relative w-full h-full overflow-hidden font-sans" @wheel.prevent="handleWheel">
    
    <div 
      class="w-full h-full transition-transform duration-[600ms] ease-[cubic-bezier(0.25,1,0.5,1)] flex flex-col"
      :style="{ transform: `translateY(-${currentPage * 100}%)` }"
    >
      
      <!-- 第一屏：主功能入口 -->
      <div class="w-full h-full shrink-0 flex flex-col items-center justify-center relative">
        
        <!-- 标题区域 -->
        <div class="flex items-center space-x-6 mb-12">
          <img src="../assets/agent_icon.png" class="w-16 h-16 object-contain drop-shadow-sm" alt="icon" />
          <h1 class="text-5xl md:text-6xl font-title-heavy black-gold-flow-text tracking-wide drop-shadow-sm">
            绘真建筑 | 建筑案例大模型
          </h1>
        </div>

        <p class="text-gray-600 mb-8 text-center max-w-xl text-lg tracking-wider leading-relaxed font-medium">
          基于深度学习的建筑案例检索与智能设计助手，<br/>快速找到灵感，高效驱动您的创意落地。
        </p>

        <!-- 核心功能卡片 (使用你自定义的 module_bg.png 背景图) -->
        <div class="flex space-x-12 mb-10 ">
          
          <!-- 案例检索 -->
          <div @click="$router.push('/search')" class="cursor-pointer group relative w-[420px] hover:-translate-y-2 transition-transform duration-300 mt-8">
            <!-- 底层背景：直接使用你的图充满容器，通过 object-fill 确保填满，或者你可以按需改成 object-contain -->
            <img src="../assets/module_bg.png" alt="bg" class="absolute inset-0 w-full h-full object-fill z-0 drop-shadow-md group-hover:drop-shadow-[0_15px_40px_rgba(224,159,91,0.25)] transition-all duration-300" />
            
            <!-- 内容层：相对定位悬浮在背景图上方 -->
            <div class="relative z-10 w-full h-full flex flex-col">
              
              <!-- 顶部：标签文字区域 (设定好固定的高度使其悬浮在图的标签区域) -->
              <div class="h-[46px] pl-8 flex items-center pt-1">
                <span class="text-white font-title-heavy text-xl tracking-wide">案例检索</span>
              </div>
              
              <!-- 下部：白色主体内容区域 -->
              <div class="px-10 pb-8 pt-6 flex flex-col justify-center h-44">
                <div class="flex justify-between items-center mb-5">
                   <!-- 放大镜 Icon -->
                   <div class="w-14 h-14 rounded-2xl bg-[#fdf8f3] flex items-center justify-center text-[#e09f5b] border border-[#f5e6d3]">
                      <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                      </svg>
                   </div>
                   <!-- 右箭头 -->
                   <div class="w-10 h-10 rounded-full bg-[#fdf8f3] flex items-center justify-center text-[#e09f5b] border border-[#f5e6d3] opacity-80 group-hover:opacity-100 transition-opacity">
                      <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                   </div>
                </div>
                <p class="text-gray-600 text-sm leading-relaxed font-medium">支持文字描述、手绘草图、实景图片三种多模态方式，精准匹配相似建筑案例。</p>
              </div>

            </div>
          </div>

          <!-- 智能策划 -->
          <div @click="$router.push('/planning')" class="cursor-pointer group relative w-[420px] hover:-translate-y-2 transition-transform duration-300 mt-8">
            <!-- 底层背景：你自定义的图 -->
            <img src="../assets/module_bg.png" alt="bg" class="absolute inset-0 w-full h-full object-fill z-0 drop-shadow-md group-hover:drop-shadow-[0_15px_40px_rgba(224,159,91,0.25)] transition-all duration-300" />
            
            <div class="relative z-10 w-full h-full flex flex-col">
              
              <div class="h-[46px] pl-8 flex items-center pt-1">
                <span class="text-white font-title-heavy text-xl tracking-wide">智能策划</span>
              </div>
              
              <div class="px-10 pb-8 pt-6 flex flex-col justify-center h-44">
                <div class="flex justify-between items-center mb-5">
                   <!-- 气泡 Icon -->
                   <div class="w-14 h-14 rounded-2xl bg-[#fdf8f3] flex items-center justify-center text-[#e09f5b] border border-[#f5e6d3]">
                      <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" class="h-7 w-7" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M8 10h.01M12 10h.01M16 10h.01M9 16H5a2 2 0 01-2-2V6a2 2 0 012-2h14a2 2 0 012 2v8a2 2 0 01-2 2h-5l-5 5v-5z" />
                      </svg>
                   </div>
                   <!-- 右箭头 -->
                   <div class="w-10 h-10 rounded-full bg-[#fdf8f3] flex items-center justify-center text-[#e09f5b] border border-[#f5e6d3] opacity-80 group-hover:opacity-100 transition-opacity">
                      <svg xmlns="[http://www.w3.org/2000/svg](http://www.w3.org/2000/svg)" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="1.5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M14 5l7 7m0 0l-7 7m7-7H3" />
                      </svg>
                   </div>
                </div>
                <p class="text-gray-600 text-sm leading-relaxed font-medium">基于多轮对话深度交互，AI 自动分析场地条件与需求，快速生成详细的设计概念企划书。</p>
              </div>

            </div>
          </div>
          
        </div>

        <div @click="scrollToNext" class="absolute bottom-8 flex flex-col items-center cursor-pointer text-archGold hover:scale-110 transition">
          <svg class="w-6 h-6 animate-bounce" viewBox="0 0 24 24" fill="currentColor">
            <path d="M2 8l10 10 10-10z"/>
          </svg>
        </div>
      </div>

      <!-- 第二屏：核心底层技术支持 (阴影渐变过渡) -->
      <div class="w-full h-full shrink-0 flex flex-col border-t border-gray-300/50 bg-gradient-to-b from-transparent to-gray-200/90 relative">
        
        <div @click="scrollToTop" class="absolute top-8 left-1/2 transform -translate-x-1/2 flex flex-col items-center cursor-pointer text-archGold hover:scale-110 transition">
          <svg class="w-6 h-6 animate-bounce rotate-180" viewBox="0 0 24 24" fill="currentColor">
            <path d="M2 16l10-10 10 10z"/>
          </svg>
        </div>

        <div class="flex-1 flex flex-col items-center justify-center w-full max-w-6xl mx-auto">
          <div class="text-center mb-16">
            <p class="text-archGold tracking-widest text-sm font-bold mb-3">CAPABILITIES</p>
            <h3 class="text-4xl text-gray-900 tracking-widest font-title-heavy">核心底层技术支持</h3>
          </div>
          <div class="grid grid-cols-3 gap-10">
            <!-- 浅色版技术卡片悬浮 -->
            <div class="bg-white/60 backdrop-blur-sm border border-gray-200 p-10 rounded-xl text-center hover:bg-white hover:shadow-md transition-all duration-300">
              <div class="text-5xl mb-6 opacity-90">🖼️</div>
              <h4 class="text-gray-900 font-title-heavy mb-4 text-xl tracking-wide">多模态检索</h4>
              <p class="text-gray-600 text-sm leading-relaxed font-medium">跨越文本与视觉的鸿沟，精准匹配相似设计，让灵感寻找不再受限于文字描述。</p>
            </div>
            <div class="bg-white/60 backdrop-blur-sm border border-gray-200 p-10 rounded-xl text-center hover:bg-white hover:shadow-md transition-all duration-300">
              <div class="text-5xl mb-6 opacity-90">🕸️</div>
              <h4 class="text-gray-900 font-title-heavy mb-4 text-xl tracking-wide">知识图谱 RAG</h4>
              <p class="text-gray-600 text-sm leading-relaxed font-medium">基于 Neo4j 构筑的深厚建筑知识底座，提供逻辑严密的图谱推理和精准溯源。</p>
            </div>
            <div class="bg-white/60 backdrop-blur-sm border border-gray-200 p-10 rounded-xl text-center hover:bg-white hover:shadow-md transition-all duration-300">
              <div class="text-5xl mb-6 opacity-90">🧠</div>
              <h4 class="text-gray-900 font-title-heavy mb-4 text-xl tracking-wide">大模型驱动</h4>
              <p class="text-gray-600 text-sm leading-relaxed font-medium">持续工程化的垂类大模型能力，提供专业级建筑常识解析与创意生成。</p>
            </div>
          </div>
        </div>
        
        <footer class="shrink-0 w-full text-center py-6 text-xs text-gray-500 bg-white/90 backdrop-blur-sm border-t border-gray-200 font-medium">
          <p>© 2026 绘真建筑 | 建筑案例大模型 - 智能建筑设计助手</p>
          <p class="mt-1 opacity-60">Powered by Qwen & Milvus</p>
        </footer>
      </div>

    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';

const currentPage = ref(0);
const isScrolling = ref(false);

const handleWheel = (e: WheelEvent) => {
  if (isScrolling.value) return;
  if (e.deltaY > 5 && currentPage.value === 0) {
    scrollToNext();
  } else if (e.deltaY < -5 && currentPage.value === 1) {
    scrollToTop();
  }
};

const scrollToNext = () => {
  if (currentPage.value === 1) return;
  isScrolling.value = true;
  currentPage.value = 1;
  setTimeout(() => { isScrolling.value = false; }, 600);
};

const scrollToTop = () => {
  if (currentPage.value === 0) return;
  isScrolling.value = true;
  currentPage.value = 0;
  setTimeout(() => { isScrolling.value = false; }, 600);
};
</script>
